import type { MultiFrameTransition } from '@/app/types';

export const calculateTotalTransitionDuration = (transitions: MultiFrameTransition[]): number => {
  return transitions.reduce((acc, curr) => acc + (Number(curr.duration) || 5), 0);
};
